import {AdminService} from "../services/adminLogin.service";
import {Component, ViewContainerRef} from "@angular/core";
import {Router} from "@angular/router";
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import {EditDataService} from "../services/edit-data.service";
/**
 * Review
 * Todo:
 * Неиспользуемый импорт
 */
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-admin',
  templateUrl: './adminLogin.html',
  providers: [ToastsManager],
  styleUrls: ['./admin.component.scss'],
})
/**
 * Review
 * Todo:
 * Названия файлов в одном стиле
 */
export class AdminLogin {
  adminPassword: any;

  constructor(public adminService: AdminService,
              public router: Router,
              public editDataService: EditDataService, vRef: ViewContainerRef,
              public toastr: ToastsManager) {

    this.toastr.setRootViewContainerRef(vRef);
  }

  loginAdmin() {
    this.adminService.checkAdmin(this.adminPassword).subscribe(
      data => {
        this.adminService.authenticate();
        this.editDataService.setPassword(this.adminPassword);
        this.router.navigate(['/admin'])
      },
      error => {
        error = JSON.parse(error._body);
        this.toastr.error(error.message, error.status_code,{dismiss: 'click'});
      })
  }
}




// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/admin/adminLogin.component.ts